/**
 * The portal JWT lives in sessionStorage under `config`, the key the React and legacy portals
 * use. Keep it: patients signed in before a deploy must stay signed in after it.
 */
const ID_TOKEN_KEY = 'config'

export function getToken(): string | null {
  return window.sessionStorage.getItem(ID_TOKEN_KEY)
}

export function saveToken(token: string): void {
  window.sessionStorage.setItem(ID_TOKEN_KEY, token)
}

export function destroyToken(): void {
  window.sessionStorage.removeItem(ID_TOKEN_KEY)
}
